import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import confetti from 'canvas-confetti';
import { PartyPopper, X, MessageCircle } from 'lucide-react';
import { Button } from '../ui/button';
import ShareSavingsDialog from '../ShareSavingsDialog';

export const MilestoneBanner = ({ milestone, capturedTotal, nextStrategy, onDismiss, renderMarkButton }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
    confetti({ particleCount: milestone.percent === 100 ? 160 : 90, spread: 75, origin: { y: 0.35 }, colors: ['#10b981', '#34d399', '#fbbf24', '#1c1917'] });
  }, [milestone.percent]);

  return (
    <div className="relative mt-4 overflow-hidden rounded-xl bg-stone-900 p-5 text-white animate-[fadeInUp_0.4s_ease-out]" data-testid={`milestone-banner-${milestone.percent}`}>
      <div className="pointer-events-none absolute -right-10 -top-10 h-32 w-32 rounded-full bg-emerald-500/25 blur-2xl" />
      <button onClick={onDismiss} aria-label="Dismiss celebration" className="absolute right-3 top-3 rounded-full p-1 text-stone-400 transition-colors hover:bg-white/10 hover:text-white" data-testid="milestone-dismiss-btn">
        <X className="h-4 w-4" />
      </button>
      <p className="flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-emerald-300">
        <PartyPopper className="h-4 w-4" /> {milestone.percent}% milestone
      </p>
      <div className="mt-1.5 flex flex-wrap items-center gap-3 pr-8">
        <p className="text-base font-semibold" data-testid="milestone-message">{milestone.message}</p>
        <ShareSavingsDialog capturedTotal={capturedTotal} testId="milestone-share-btn"
          triggerClassName="bg-transparent border-emerald-400 text-emerald-300 hover:bg-emerald-500/10 hover:text-emerald-200" />
      </div>
      {nextStrategy ? (
        <div className="mt-4 flex flex-wrap items-center gap-3" data-testid="milestone-next-move">
          <p className="mr-auto text-sm text-stone-300">
            <span className="text-stone-400">Next best move:</span> {nextStrategy.title} <span className="font-mono text-emerald-300">{nextStrategy.display}</span>
          </p>
          {renderMarkButton(nextStrategy)}
          <Button size="sm" variant="ghost" onClick={() => navigate('/chat')} className="rounded-full text-stone-300 hover:bg-white/10 hover:text-white" data-testid="milestone-ask-advisor-btn">
            <MessageCircle className="mr-1.5 h-4 w-4" /> Ask an advisor
          </Button>
        </div>
      ) : (
        <p className="mt-2 text-sm text-stone-300">Every tracked strategy is in action. Share your progress with your CPA at your next check-in.</p>
      )}
    </div>
  );
};

export default MilestoneBanner;
